import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d40911a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "content-tabs flex"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "tabs-title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "active-bg" }, null, -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("设为默认地址")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("默认地址")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_ReportTable = _resolveComponent("ReportTable")!
  const _component_AdminTableLayout = _resolveComponent("AdminTableLayout")!

  return (_openBlock(), _createBlock(_component_AdminTableLayout, {
    needSearchForm: false,
    searchDisabled: _ctx.loading,
    isDialog: _ctx.isDialog
  }, {
    "content-header": _withCtx(() => [
      (!_ctx.isDialog)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
              return (_openBlock(), _createElementBlock("li", {
                key: tab.value,
                onClick: ($event: any) => (_ctx.formData.type = tab.value),
                class: _normalizeClass({ active: _ctx.formData.type === tab.value })
              }, [
                _createElementVNode("div", _hoisted_3, _toDisplayString(tab.label), 1),
                _hoisted_4
              ], 10, _hoisted_2))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (!_ctx.isDialog)
        ? (_openBlock(), _createBlock(_component_el_divider, { key: 1 }))
        : _createCommentVNode("", true),
      _createVNode(_component_el_button, {
        class: _normalizeClass(["system-btn", { 'mb-20': _ctx.isDialog }]),
        type: "primary",
        size: "mini",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleEdit()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(" 新增" + _toDisplayString(_ctx.formData.type==0?"发货地址":"客户地址"), 1)
        ]),
        _: 1
      }, 8, ["class"])
    ]),
    "content-table": _withCtx(() => [
      _createVNode(_component_ReportTable, {
        ref: "multipleTableRef",
        loading: _ctx.loading,
        tableData: _ctx.tableData,
        class: _normalizeClass({'send-addr': _ctx.formData.type==0}),
        emptyText: "暂无地址信息，您可手动添加后保存至地址薄",
        showTableColumn: _ctx.showTableColumn,
        onChangeSelection: _ctx.handleSelect
      }, {
        actions: _withCtx(({ row }) => [
          _createVNode(_component_el_link, {
            class: "mr-8",
            type: "primary",
            onClick: ($event: any) => (_ctx.handleDelete(row))
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 2
          }, 1032, ["onClick"]),
          _createVNode(_component_el_link, {
            class: "mr-8",
            type: "primary",
            onClick: ($event: any) => (_ctx.handleEdit(row))
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 2
          }, 1032, ["onClick"]),
          (_ctx.formData.type==0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (row.defaultAddress==1)
                  ? (_openBlock(), _createBlock(_component_el_link, {
                      key: 0,
                      type: "primary",
                      onClick: ($event: any) => (_ctx.handleDefault(row))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      type: "primary",
                      size: "mini",
                      style: {"cursor":"inherit"}
                    }, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 1
                    }))
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["loading", "tableData", "class", "showTableColumn", "onChangeSelection"])
    ]),
    _: 1
  }, 8, ["searchDisabled", "isDialog"]))
}